import { render } from "./AdminRole.vue?vue&type=template&id=49b689ba"
import script from "./AdminRole.vue?vue&type=script&lang=js"
export * from "./AdminRole.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__